import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

// components
import { AnalyticsProps } from '@inplayer-org/inplayer-ui';
import { PreviewBox, Image, Title, Button, Description, ContentWrapper } from './StyledElements';

const StyledPreviewBox = styled(PreviewBox)`
  height: 83%;
`;

const StyledImage = styled(Image)`
  height: 83%;
`;

const StyledContentWrapper = styled(ContentWrapper)`
  width: 60%;
  position: absolute;
  bottom: 2rem;
  left: 13%;
`;

const StyledButton = styled(Button)`
  width: 12px;
  height: 12px;
  position: absolute;
  bottom: 20px;
  right: 0%;
`;

interface OwnProps extends AnalyticsProps {
  id: number;
  onBodyClick: (id: number) => void;
  isTemplateSelected: boolean;
}

const PreviewTemplate3: FunctionComponent<OwnProps> = ({ id, onBodyClick, isTemplateSelected }) => {
  const onClick = () => onBodyClick(id);

  return (
    <StyledPreviewBox onClick={onClick} isTemplateSelected={isTemplateSelected}>
      <StyledImage isTemplateSelected={isTemplateSelected} />
      <StyledContentWrapper>
        <Title />
        <Description />
        <Description />
        <Description />
        <StyledButton isTemplateSelected={isTemplateSelected} />
      </StyledContentWrapper>
    </StyledPreviewBox>
  );
};

export default PreviewTemplate3;
